import React from 'react';
import ShapeBrowser from './ShapeBrowser';
import { CATEGORIES, CATEGORY_IDS } from './shapeLibrary';
import { ClearIcon, CollapseIcon, HandIcon, SearchIcon } from './sidebarIcons';

const ALL = 'all';

const SearchBox = ({ inputRef, query, onQuery }) => (
    <div className="shape-search">
        <label htmlFor="shape-search" className="visually-hidden">Search shapes</label>
        <span className="shape-search-icon"><SearchIcon /></span>
        <input
            ref={inputRef}
            id="shape-search"
            type="text"
            className={`shape-search-input ${query ? 'has-query' : ''}`}
            placeholder="Search shapes"
            autoComplete="off"
            value={query}
            onChange={(event) => onQuery(event.target.value)}
        />
        {query ? (
            <button type="button" className="shape-search-clear" aria-label="Clear search" onClick={() => onQuery('')}>
                <ClearIcon />
            </button>
        ) : (
            <span className="shape-search-key" aria-hidden="true">/</span>
        )}
    </div>
);

// The four categories as a 2 × 2 grid. Nothing chosen shows every category; clicking the chosen one again clears it.
const CategoryChips = ({ category, onCategory }) => (
    <div className="category-chips" role="group" aria-label="Filter by category">
        {CATEGORY_IDS.map((id) => {
            const isOn = id === category;
            return (
                <button
                    key={id}
                    type="button"
                    className={`category-chip ${isOn ? 'is-on' : ''}`}
                    aria-pressed={isOn}
                    title={isOn ? 'Show all categories' : `Show only ${CATEGORIES[id].label}`}
                    onClick={() => onCategory(isOn ? ALL : id)}
                >
                    <span className="category-dot" style={{ background: isOn ? '#FFFFFF' : CATEGORIES[id].stroke }} />
                    <span className="category-chip-label">{CATEGORIES[id].label}</span>
                    {isOn && <span className="category-chip-clear"><ClearIcon /></span>}
                </button>
            );
        })}
    </div>
);

// The expanded sidebar: title, search, category filters, the shapes, and a drag hint.
const ShapePanel = ({ inputRef, query, onQuery, category, onCategory, onCollapse, onReset, results, recent, dragProps }) => (
    <div className="shape-panel">
        <div className="shape-panel-top">
            <div className="shape-panel-header">
                <h2 className="shape-panel-title">Shapes</h2>
                <button type="button" className="sidebar-icon-button" aria-label="Collapse sidebar" onClick={onCollapse}>
                    <CollapseIcon />
                </button>
            </div>
            <SearchBox inputRef={inputRef} query={query} onQuery={onQuery} />
            <CategoryChips category={category} onCategory={onCategory} />
        </div>
        <div className="shape-panel-body">
            <ShapeBrowser
                query={query}
                category={category}
                results={results}
                recent={recent}
                dragProps={dragProps}
                onReset={onReset}
            />
        </div>
        <div className="shape-panel-footer">
            <HandIcon />
            Drag a shape onto the mind map
        </div>
    </div>
);

export default ShapePanel;
